/* unplugin-vue-components disabled */import script from "./PointTurnoverModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PointTurnoverModal.vue?vue&type=script&setup=true&lang=js"

import "./PointTurnoverModal.vue?vue&type=style&index=0&id=ad67b28e&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/wyt-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ad67b28e"]])

export default __exports__